import { TipoEnvioComprovanteEnum } from "../enums/tipo-envio-comprovante-enum";

export class EnvioComprovanteDTO {

    tipoEnvio: TipoEnvioComprovanteEnum | null = null;

    dataInicial: Date | null = null;

    dataFinal: Date | null = null;

    nomePaciente: string | null = '';

    cpfPaciente: string | null = '';

    emailEnvioPaciente: string | null = '';

    celularEnvioPaciente: string | null = '';

    dataNascimentoPaciente: Date | null = null;

    envioSucesso: boolean | null = null;

    constructor() {
    }

    temCampoSelecionado(): boolean {

        let teste: boolean = false;

        if (this.tipoEnvio) {
            teste = true;
        } else if (this.dataInicial) {
            teste = true;
        } else if (this.dataFinal) {
            teste = true;
        } else if (this.nomePaciente) {
            teste = true;
        } else if (this.cpfPaciente) {
            teste = true;
        } else if (this.emailEnvioPaciente) {
            teste = true;
        } else if (this.celularEnvioPaciente) {
            teste = true;
        } else if (this.dataNascimentoPaciente) {
            teste = true;
        } else if (this.envioSucesso) {
            teste = true;
        }

        return teste;
    }
}
